module.exports = __webpack_public_path__ + "img/comment-placeholder.7a01551e.png";